export const builderReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_BUILDERS_LIST_REQUEST":
      return {
        loading: true,
        builders: null,
      };
    case "GET_BUILDERS_LIST_SUCCESS":
      return {
        loading: false,
        builders: action.payload,
      };
    case "GET_BUILDERS_LIST_FAILED":
      return {
        loading: false,
        builders: action.payload,
      };
    case "GET_BUILDER_REQUEST":
      return {
        loading: true,
        builder: null,
      };
    case "GET_BUILDER_SUCCESS":
      return {
        loading: false,
        builder: action.payload,
      };
    case "GET_BUILDER_FAILED":
      return {
        loading: false,
        builder: action.payload,
      };
    case "ADD_NEW_BUILDER_REQUEST":
      return {
        loading: true,
        builders: null,
      };
    case "ADD_NEW_BUILDER_SUCCESS":
      return {
        loading: false,
        builders: action.payload,
      };
    case "ADD_NEW_BUILDER_FAILED":
      return {
        loading: false,
        builders: action.payload,
      };
    case "CHANGE_BUILDER_STATUS_REQUEST":
      return {
        loading: true,
        builders: null,
      };
    case "CHANGE_BUILDER_STATUS_SUCCESS":
      return {
        loading: false,
        builders: action.payload,
        builder: action.payload,
      };
    case "CHANGE_BUILDER_STATUS_FAILED":
      return {
        loading: false,
        builders: action.payload,
      };
    default:
      return state;
  }
};
